import varAxios from "../../Comman/axios";
import {AddUpdateRegionUrl, DeleteRegionUrl,GetRegionListUrl} from '../../Comman/apiEndPoints';

export const Fetch_All_Region_Data = "Fetch_All_Region_Data";
export const Update_Region_List_Success = "Update_Region_List_Success";
export const Region_Data_Success = "Region_Data_Success";
export const Fetch_Region_Request = "Fetch_Region_Request";

export function getAllRegionSettings() {
      let requestPayload={
    UserId:sessionStorage.getItem('SuperAdminUserID')
  }
    return(dispatch) =>{
       return varAxios.post(GetRegionListUrl,requestPayload,
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
       .then(response => {
          dispatch(
            fetchAllRegionData({
              errorCode : response.data.errorCode,
              statusCode : response.data.statusCode,
              regionList : response.data.regionList
             }));
       })
       .catch((error) => {
          console.log("error",error);
      })
    }
}
export function fetchAllRegionData({errorCode, statusCode, regionList}) {
  return {
    type : Fetch_All_Region_Data,
    errorCode,
    statusCode,
    regionList
  }
}
export function addRegionData(formData) {
  return (dispatch) => {
      dispatch(fetchRegionRequest())
      return varAxios.post(AddUpdateRegionUrl, formData,
          JSON.stringify({
              derived: 'd',
              message: 'e'
          }))
          .then((response) => {
             /*  dispatch(
                  updateRegionList(response.data.errorCode,response.data.statusCode,
                    [],response.data.Message)
              ); */
          })
          .catch((error) => {
              console.log(error)
          })
  }
}
export function updateRegionList(errorCode,statusCode,regionList,message) {
  return{
    type : Update_Region_List_Success,
    errorCode,
    statusCode,
    regionList,
    message
  } 
}

export function deleteRegionData(id) {
  return (dispatch) => {
    dispatch(fetchRegionRequest())
      return varAxios.post(DeleteRegionUrl,{ ID : id},
          JSON.stringify({
              derived: 'd',
              message: 'e'
          }))
          .then((response) => {
              dispatch(
                  RegionDataSuccess(response.data.errorCode,response.data.statusCode,
                    response.data.Message)
              );
               return Promise.resolve(response.data);
          })
          .catch((error) => {
              console.log(error)
          })
  }
}
export function RegionDataSuccess(errorCode,statusCode,Message,list) {
  return{
    type : Region_Data_Success,
    errorCode,
    statusCode,
    Message,
    list
  } 
}
export function editRegionData(formData) {
  return (dispatch) => {
    dispatch(fetchRegionRequest())
      return varAxios.post(AddUpdateRegionUrl, formData,
          JSON.stringify({
              derived: 'd',
              message: 'e'
          }))
          .then((response) => {
              dispatch(
                RegionDataSuccess(response.data.errorCode,response.data.statusCode,
                  response.data.Message,response.data.List)
              );
          })
          .catch((error) => {
              console.log(error)
          })
  }
}
export function fetchRegionRequest(){
  return{
    type : Fetch_Region_Request
  }
}
